<!-- <a href="#" target="_blank" class="logo"></a> -->
<div class="logo">
  <img src="assets/img/App-Biodata.png" alt="" class="logo-img">
</div>

